import {ViewPopup} from '../../ui_popup/ViewPopup'

export class UIRoomExitConfirmationViewPopup extends ViewPopup {
    constructor(leaveAction: () => void) {
        super({key: 'strings:roomPage.leaveRoom.title'}, {key: 'strings:roomPage.leaveRoom.body'}, leaveAction, () => undefined, false, undefined)
        this.show()
    }
}
